<template>
  <div class="manage">
    <div class="tabs">
      <div
        v-for="(item, index) in state"
        :key="index"
        class="btn"
        :class="index == nowIDx ? 'selectBtn' : ''"
        @click="cutState(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="flex">
      <div>
        <el-button size="small" type="primary" @click="goCreateGoods"
          >添加商品</el-button
        >
        <el-button size="small" @click="amendProducts(2)">删除商品</el-button>
      </div>
      <div class="flex">
        <el-input
          placeholder="请输入商品名称"
          v-model="keyword"
          clearable
          size="small"
        ></el-input>
        <el-button type="primary" size="small">搜索</el-button>
      </div>
    </div>
    <el-table
      ref="multipleSelection"
      :data="commodityList"
      @selection-change="handleSelectionChange"
      v-loading="loading"
      :element-loading-text="loading_text"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="序号" sortable></el-table-column>

      <el-table-column label="商品 价格" width="180" sortable>
        <template slot-scope="scope">
          <div class="comPrice">
            <div class="img">
              <img :src="scope.row.image[0].url" alt="" class="comImg" />
            </div>
            <div class="rgt">
              <span class="name">{{ scope.row.name }}</span>
              <span class="price">￥{{ scope.row.price }}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="stock" label="访问量" width="180" sortable>
              <template slot-scope="scope">
                <div class="comPrice">
                  <div class="rgt">
                    <span>访客数：{{ scope.row.view_num }}</span>
                    <span>浏览量：{{ scope.row.view_num }}</span>
                  </div>
                </div>
              </template>
            </el-table-column> -->
      <el-table-column prop="stock" label="库存" sortable></el-table-column>
      <el-table-column prop="sale_num" label="销量" sortable></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180">
      </el-table-column>
      <el-table-column label="状态" width="180">
        <template slot-scope="scope">
          <div class="comPrice">
            <div class="rgt" @click="changestatus(scope.row.id)">
              <el-tag
                type="success"
                effect="dark"
                v-if="scope.row.marketable == 1"
              >
                已上架
              </el-tag>
              <el-tag v-else type="danger" effect="dark">
                未上架
              </el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row.id)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!-- 添加商品的弹窗 -->
    <el-dialog title="商品来源" :visible.sync="addProduct">
      <div class="box" style="text-align:center">
        <el-button
          type="primary"
          class="el-icon-plus"
          @click="goCreateGoods(0)"
        >
          新建
        </el-button>
        <el-button
          type="primary"
          class="el-icon-document"
          @click="goCreateGoods(1)"
        >
          从原商品复制
        </el-button>
        <el-button
          type="primary"
          class="el-icon-news"
          @click="goCreateGoods(2)"
        >
          从供货方商品挑选
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getComList,
  deleteProduct,
  getLabeldataApi,
  shelvesApi
} from "@/api/mall";
import { mapGetters, mapActions } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      idx: 1,
      keyword: "",
      page: "1",
      total: 0,
      nowIDx: 0,
      loading: true,
      loading_text: "正在加载中...",
      state: ["全部商品", "出售中", "已售罄", "仓库中"],
      tableData: [],
      labelData: [],
      labelDatas: [],
      value: "",
      input: "",
      // 选中
      multipleSelection: [],
      commodityList: [],
      // 添加商品弹窗
      addProduct: false
    };
  },
  watch: {
    labelDatas: () => {
      console.log("我变化");
    }
  },
  mounted() {
    this.getcomLists();
  },
  methods: {
    ...mapActions(["sethttp"]),
    changestatus(id) {
      console.log("status");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getcomLists();
    },
    // 筛选
    getLabel() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        name: this.screenInput
      };
      getLabeldataApi(data).then(res => {
        console.log("标签", res);
        this.labelDatas = res.data;
        console.log("DA", this.labelDatas);
      });
    },
    // 切换
    cutState(index) {
      this.nowIDx = index;
      this.getcomLists(index);
    },
    // 编辑商品
    handleEdit(index) {
      this.$router.push({ name: "editorProduct", query: { idE: index } });
    },
    // 删除商品 index 区分 jude 用于判断是否上架
    amendProducts(index, jude = 0) {
      if (this.multipleSelection == "") {
        this.$message.warning("请选择要删除的商品");
      } else {
        var multipleSelectionArr = this.multipleSelection;
        var idarr = [];
        for (var i = 0; i < multipleSelectionArr.length; i++) {
          idarr.push(multipleSelectionArr[i].id);
        }
        var goods_id = idarr.join(",");
        let data = {
          token: this.token,
          app_id: this.app_id,
          goods_id: goods_id,
          marketable: jude
        };
        switch (index) {
          case 0:
            // 上架
            this.shelves(data);
            break;
          case 1:
            // 下架
            this.shelves(data);
            break;
          case 2:
            // 删除
            delete data.marketable;
            this.delet(data);
            break;
        }
      }
    },
    // 推广
    handleDelete(index, row) {
      console.log(index, row);
    },
    // 选中的商品
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 商品来源去向
    goCreateGoods(index) {
      var url = "";
      switch (index) {
        case 0:
          url = "manage";
          // url = "mallManagement/choseClassify";
          break;
        case 1:
          url = "addProduct";
          break;
        default:
          url = "editorProduct";
      }
      this.$router.push(url);
    },
    // 状态列表
    getcomLists(idx = 0) {
      this.loading = true;
      const statusArr = [
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          marketable: 1
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          stock: 1
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          marketable: 2
        }
      ];
      this.commodityList = [];
      getComList(statusArr[idx]).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.data.length > 0) {
            setTimeout(() => {
              this.loading = false;
              this.commodityList = res.data;
              this.total = res.total;
            }, 400);
          } else {
            this.loading = false;
            this.loading_text = "暂无数据...";
          }
        } else {
          this.loading_text = "获取数据失败....";
          setTimeout(() => {
            this.loading = false;
            this.$message.warning(res.msg);
            this.total = res.total;
          }, 800);
        }
      });
    },
    // 批量上架、下架
    shelves(data) {
      shelvesApi(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "warning"
        });
        this.reload();
      });
    },
    // 删除
    delet(data) {
      deleteProduct(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "warning"
        });
        this.reload();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  display: flex;
  flex-direction: column;
  .tabs {
    font-size: 14px;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .btn {
      width: 90px;
      height: 30px;
      margin-right: 10px;
      text-align: center;
      line-height: 30px;
      border-radius: 16px;
    }
    .selectBtn {
      background: #397dff;
      color: #fff;
      cursor: pointer;
    }
  }
  .filtrate {
    height: 36px;
    .top-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
  }
  .el-input {
    max-width: 200px;
  }
  .comPrice {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .img {
      width: 50px;
      height: 50px;
      overflow: hidden;
      line-height: 50px;
      .comImg {
        vertical-align: middle;
        width: 50px;
      }
    }
    .rgt {
      width: 60px;
      height: 50px;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 14px;
      text-align: left;
      .name {
        color: rgba(3, 87, 255, 1);
        font-weight: 400;
        line-height: 21px;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;

        text-overflow: ellipsis;
      }
      .price {
        color: rgba(255, 91, 3, 1);
        font-weight: 400;
        line-height: 21px;
      }
    }
  }
  .el-pagination {
    height: 60px;
    padding-top: 16px;
  }
}
</style>

<style lang="scss">
.manage {
  .el-button--small {
    padding: 9px 27px;
  }
  .cell {
    text-align: center;
  }
}
</style>
